<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Privacy Policy</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Privacy Policy</li>
            </ul>
        </div>
    </div>
</div>

<div class="about-area position-relative overflow-hidden space mt-auto" id="privacy-sec">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <p>We will not use or share your information with anyone except as described in this Privacy Policy.</p>

                <p>We use your personal Information for providing and improving the Service. By using the Service, you
                    agree to the collection and use of information in accordance with this policy. Unless otherwise
                    defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our
                    Terms and Conditions, accessible at <a routerLink="">https://www.xipetech.com</a>
                </p>
            </div>
            <div class="col-md-12">
                <h3>Who we are</h3>
                <p>We are not just a team of IT professionals; we are a dynamic ensemble of visionaries, problem
                    solvers,
                    and creative minds. Our diverse expertise spans across software development, mobile app development,
                    quality assurance, and UI/UX design. What sets us apart is not just our technical proficiency but
                    our
                    passion for exploring new possibilities and finding innovative solutions to complex challenges.</p>

                <h3>Information Collection And Use</h3>
                <p>While using our service, we may ask you to provide us with certain personally identifiable
                    information
                    that can be used to contact or identify you. Personally identifiable information (“Personal
                    Information”) may include, but is not limited to:</p>

                <ul>
                    <li>Email address</li>
                    <li>Telephone number</li>
                    <li>Address</li>
                </ul>

                <h3>Log Data</h3>
                <p>We collect information that your browser sends whenever you visit our service (“Log Data”). This Log
                    Data may include information such as your computer’s Internet Protocol (“IP”) address, browser type,
                    browser version, the pages of our service that you visit, the time and date of your visit, the time
                    spent on those pages and other statistics.</p>

                <h3>Google AdSense & DoubleClick Cookie</h3>
                <p>Google, as a third party vendor, uses cookies to serve ads on our Service.</p>

                <h3>Cookies</h3>
                <p>Cookies are files with small amount of data, which may include an anonymous unique identifier.
                    Cookies
                    are sent to your browser from a web site and stored on your computer’s hard drive.</p>

                <p>We use “cookies” to collect information. You can instruct your browser to refuse all cookies or to
                    indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to
                    use
                    some portions of our Service.</p>

                <h3>Service Providers</h3>
                <p>We may employ third party companies and individuals to facilitate our Service, to provide the Service
                    on
                    our behalf, to perform Service-related services or to assist us in analyzing how our Service is
                    used.</p>

                <p>These third parties have access to your Personal Information only to perform these tasks on our
                    behalf
                    and are obligated not to disclose or use it for any other purpose.</p>

                <h3>Security</h3>
                <p>The security of your Personal Information is important to us, but remember that no method of
                    transmission over the Internet, or method of electronic storage is 100% secure. While we strive to
                    use
                    commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute
                    security.</p>

                <h3>Links To Other Sites</h3>
                <p>Our Service may contain links to other sites that are not operated by us. If you click on a third
                    party
                    link, you will be directed to that third party’s site. We strongly advise you to review the Privacy
                    Policy of every site you visit.</p>

                <p>We have no control over, and assume no responsibility for the content, privacy policies or practices
                    of
                    any third party sites or services.</p>

                <h3>Children’s Privacy</h3>
                <p>Our Service does not address anyone under the age of 18 (“Children”).</p>

                <p>We do not knowingly collect personally identifiable information from children under 18. If you are a
                    parent or guardian and you are aware that your child has provided us with Personal Information,
                    please
                    contact us. If we discover that a child under 18 has provided us with Personal Information, we will
                    delete such information from our servers immediately.</p>


                <h3>Compliance With Laws</h3>
                <p>We will disclose your Personal Information where required to do so by law or subpoena.</p>

                <h3>Changes To This Privacy Policy</h3>
                <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the
                    new
                    Privacy Policy on this page.</p>

                <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy
                    Policy are effective when they are posted on this page.</p>

                <h3>Comments</h3>
                <p><strong>Suggested text:</strong> When visitors leave comments on the site we collect the data shown
                    in the comments form,
                    and also the visitor’s IP address and browser user agent string to help spam detection.</p>

                <h3></h3>Media
                <p><strong>Suggested text:</strong> If you upload images to the website, you should avoid uploading
                    images with embedded
                    location data (EXIF GPS) included. Visitors to the website can download and extract any location
                    data
                    from images on the website.</p>

                <h3>Cookies</h3>
                <p><strong>Suggested text:</strong> If you leave a comment on our site you may opt-in to saving your
                    name, email address and
                    website in cookies. These are for your convenience so that you do not have to fill in your details
                    again
                    when you leave another comment. These cookies will last for one year.</p>

                <p>If you visit our login page, we will set a temporary cookie to determine if your browser accepts
                    cookies. This cookie contains no personal data and is discarded when you close your browser.</p>

                <p>When you log in, we will also set up several cookies to save your login information and your screen
                    display choices. Login cookies last for two days, and screen options cookies last for a year. If you
                    select “Remember Me”, your login will persist for two weeks. If you log out of your account, the
                    login
                    cookies will be removed.</p>

                <p>If you edit or publish an article, an additional cookie will be saved in your browser. This cookie
                    includes no personal data and simply indicates the post ID of the article you just edited. It
                    expires
                    after 1 day.</p>

                <h3>Embedded content from other websites</h3>
                <p><strong>Suggested text:</strong> Articles on this site may include embedded content (e.g. videos,
                    images, articles,
                    etc.). Embedded content from other websites behaves in the exact same way as if the visitor has
                    visited
                    the other website.</p>

                <p>These websites may collect data about you, use cookies, embed additional third-party tracking, and
                    monitor your interaction with that embedded content, including tracking your interaction with the
                    embedded content if you have an account and are logged in to that website.</p>

                <h3>Who we share your data with</h3>
                <p><strong>Suggested text:</strong> If you request a password reset, your IP address will be included in
                    the reset email.</p>

                <h3>How long we retain your data</h3>
                <p><strong>Suggested text:</strong> If you leave a comment, the comment and its metadata are retained
                    indefinitely. This is
                    so we can recognize and approve any follow-up comments automatically instead of holding them in a
                    moderation queue.</p>

                <p>For users that register on our website (if any), we also store the personal information they provide
                    in
                    their user profile. All users can see, edit, or delete their personal information at any time
                    (except
                    they cannot change their username). Website administrators can also see and edit that information.
                </p>

                <h3>What rights you have over your data</h3>
                <p><strong>Suggested text:</strong> If you have an account on this site, or have left comments, you can
                    request to receive
                    an exported file of the personal data we hold about you, including any data you have provided to us.
                    You
                    can also request that we erase any personal data we hold about you. This does not include any data
                    we
                    are obliged to keep for administrative, legal, or security purposes.</p>

                <h3>Where your data is sent</h3>
                <p><strong>Suggested text:</strong> Visitor comments may be checked through an automated spam detection
                    service.</p>
            </div>

        </div>
    </div>
</div>

<!--======== Footer Section ========-->
<app-footer></app-footer>